import React, { useState, useEffect, useRef } from "react";
import styles from "./event.module.css";
import useAuth from "../../../hooks/Auth/useAuth.js";
import { ROLES } from "../../../redux/context/allowedTypes.js";
import EventItem from "./eventItem.js";
import axios from "axios";

import { useNavigate } from "react-router-dom";
import errorSound from "./error_sound.mp3";
import SortChipRow from "./SortChipRow";
import CartAudioRecorderModal from "../../modals/CartAudioRecorderModal.js";
import CartCameraModal from "../../modals/CartCameraModal.js";
import common_types from "../../../common_files/common_types";

export default function Event({
  sitesEventObject,
  setSitesEventObject,
  eventsContainerOpen,
  setEventsContainerOpen,
  eventContainerRef,
}) {
  let { sitesSockectsConnection, relevantSite, role, auth, relevantUrl, isPhoneSize } = useAuth();
  let [openMalfuntionDialog, setOpenMalfuntionDialog] = useState(false);
  let [openDialog, setOpenDialog] = useState(false);
  const [malfunctionDialogData, setMalfunctionDialogData] = useState(null);
  let [assisCartEventObject, setAssistCartEventObject] = useState(null);
  const [eventSearchVal, setEventSearchVal] = useState("");
  const navigate = useNavigate();
  const [sortOption, setSortOption] = useState('cart_id');
  const [sortDirection, setSortDirection] = useState("asc");

  const audioRef = useRef(null);
  const [isAudioUnlocked, setIsAudioUnlocked] = useState(false);
  const queuedSounds = useRef([]);

  const [openCameras, setOpenCameras] = React.useState(false);
  const [openRecorder, setOpenRecorder] = useState(false); // New state for the audio recorder modal
  const [cartModalControlId, setCartModalControlId] = useState(0); // State to hold cart ID for the recorder modal
  const openRecorderModal = (cartid) => {setCartModalControlId(cartid);  setOpenRecorder(true);} // Open recorder modal
  const closeRecorderModal = () => {setOpenRecorder(false); setCartModalControlId(null);} // Close recorder modal

  const openCamerasModal = (cartid) => {setCartModalControlId(cartid);  setOpenCameras(true);}
  const closeCamerasModal = () => {setOpenCameras(false); setCartModalControlId(null);}



  const EVENT_SEVERITY_ENUM = common_types.event_severity_enum;

  const highString = EVENT_SEVERITY_ENUM.SEVERITY_HIGH;
  const midString = EVENT_SEVERITY_ENUM.SEVERITY_MEDIUM;
  const lowString = EVENT_SEVERITY_ENUM.SEVERITY_LOW;

  useEffect(() => {
    // Create the Audio object
    audioRef.current = new Audio(errorSound);

    // Unlock audio playback for Safari and other strict browsers
    const unlockAudio = () => {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      if (audioContext.state === "suspended") {
        audioContext.resume().then(() => {
          console.log("Audio context resumed");
        });
      }

      // Play queued sounds
      while (queuedSounds.current.length > 0) {
        const sound = queuedSounds.current.shift();
        sound.currentTime = 0;
        sound.play().catch((err) => {
          console.error("Error playing queued sound:", err);
        });
      }

      setIsAudioUnlocked(true);
      window.removeEventListener("click", unlockAudio);
      window.removeEventListener("touchstart", unlockAudio);
    };

    window.addEventListener("click", unlockAudio);
    window.addEventListener("touchstart", unlockAudio);

    return () => {
      window.removeEventListener("click", unlockAudio);
      window.removeEventListener("touchstart", unlockAudio);
    };
  }, []);

  const playErrorSound = () => {
    if (audioRef.current) {
      if (isAudioUnlocked) {
        audioRef.current.currentTime = 0; // Rewind to start
        audioRef.current.play().catch((err) => {
          console.error("Failed to play error sound:", err);
        });
      } else {
        // Queue the sound to be played later
        queuedSounds.current.push(audioRef.current);
      }
    }
  };







 // Update sortEvents to include the direction
// Updated sortEvents function with multi-level sorting:
const sortEvents = (events) => {
  if (!events) return [];
  const sorted = events.slice(); // clone the array so as not to affect the original

  // Define a custom severity order mapping
  const severityOrder = { 
    [highString]: 1, 
    [midString]: 2, 
    [lowString]: 3 
  };

  // Choose the order of sort keys based on the selected primary sort option.
  // Adjust the order of the backup fields to your needs.
  let sortOrder;
  if (sortOption === "severity") {
    sortOrder = ["severity", "cart_id", "open_date_time"];
  } else if (sortOption === "cart_id") {
    sortOrder = ["cart_id", "severity", "open_date_time"];
  } else if (sortOption === "open_date_time") {
    sortOrder = ["open_date_time", "severity", "cart_id"];
  }

  // Determine multiplier for the primary field based on user selected sort direction.
  // For the primary sort, if the direction is descending, we multiply by -1.
  const primaryMultiplier = sortDirection === "desc" ? -1 : 1;

  // Use a custom comparator that iterates through our sort keys (from primary to tertiary)
  sorted.sort((a, b) => {
    for (let i = 0; i < sortOrder.length; i++) {
      const field = sortOrder[i];
      let aVal, bVal;

      if (field === "severity") {
        // Use our custom mapping for severity
        aVal = severityOrder[a.severity] || 99;
        bVal = severityOrder[b.severity] || 99;
      } else if (field === "open_date_time") {
        // Convert date strings to timestamps for comparison
        aVal = new Date(a.open_date_time).getTime();
        bVal = new Date(b.open_date_time).getTime();
      } else if (field === "cart_id") {
        aVal = a.cart_id;
        bVal = b.cart_id;
      } else {
        // Fallback for any other field
        aVal = a[field];
        bVal = b[field];
      }

      // For the primary field (i==0) apply the user's sort direction; for backup levels, always use ascending order.
      const multiplier = i === 0 ? primaryMultiplier : 1;
      if (aVal < bVal) return -1 * multiplier;
      if (aVal > bVal) return 1 * multiplier;
      // If values are equal, then the next sort key will decide
    }
    return 0; // all sort keys are equal
  });

  return sorted;
};




  // in case of assist cart malfunction dialog open , should updae data in real time
  useEffect(() => {
    if (openMalfuntionDialog && sitesEventObject) {
      let updatedEvent = null;
      if (Object.keys(sitesEventObject).length > 0) {
        for (const eventArray of Object.values(sitesEventObject)) {
          for (const eventItem of eventArray) {
            if (eventItem.eventId === malfunctionDialogData.eventId) {
              updatedEvent = eventItem;
            }
          }
        }
      }

      if (updatedEvent) {
        setMalfunctionDialogData(updatedEvent);
      } else {
        setOpenMalfuntionDialog(false);
        setMalfunctionDialogData(null);
      }
    }
  }, [openMalfuntionDialog, sitesEventObject]);

  const assistCart = (cartId, eventId, eventName, blockedImg) => {
    const newAssistCart = {
      cartId: cartId,
      eventId: eventId,
      eventName: eventName,
      blockedImg: blockedImg,
    };

    setAssistCartEventObject(newAssistCart);
    setOpenDialog(true);
  };

  const showMalfunctionModal = (p_event) => {
    setOpenMalfuntionDialog(true);
    setMalfunctionDialogData(p_event);
  };

  const resolveEvent = async (p_eventId) => {
    // Find the category and event index
    let category, eventIndex;
    for (const key in sitesEventObject) {
      eventIndex = sitesEventObject[key].findIndex(
        (event) => event.eventId === p_eventId
      );
      if (eventIndex !== -1) {
        category = key;
        break;
      }
    }

    if (category !== undefined && eventIndex !== -1) {
      // Create a copy of the state
      const newSitesEventObject = { ...sitesEventObject };
      const [removedEvent] = newSitesEventObject[category].splice(
        eventIndex,
        1
      );

      // Update the state
      setSitesEventObject(newSitesEventObject);

      try {
        axios.post(relevantUrl + "/admin/deleteEvent", { eventId: p_eventId });
      } catch (error) {
        // If the request fails, add the event back to the sitesEventObject
        newSitesEventObject[category].splice(eventIndex, 0, removedEvent);
        setSitesEventObject(newSitesEventObject);
      }
    }
  };

  const focusOnCart = (p_cartId) => {
    navigate("/dashboard_site", {
      state: { cartID: p_cartId }
    });
    return;
  };

  const callBack = (userId) => {
    if (sitesSockectsConnection && relevantSite) {
      const relevant_socket = sitesSockectsConnection[relevantSite];

      if (relevant_socket) {
        relevant_socket.emit("getUserDetails", userId);
      }
    } else {
      console.log(
        "Call Back failed ",
        sitesSockectsConnection,
        " ",
        relevantSite
      );
    }
  };

  
  return (
    <div>

      {auth &&
      auth.userName &&
      role &&
      role !== ROLES.SITE_MANAGER &&
      (eventsContainerOpen || isPhoneSize) ? (
        <div className={`${styles.events_alerts_body_open} ${isPhoneSize ? styles.mobile_events : ''}`} ref={eventContainerRef}>
          {/* Events Section */}
          <div className={styles.split_container}>
            <div className={styles.events_section}>
              <div className={styles.cotainer_header}>
              <div
                className={styles.center_row}
                style={{
                  width: "100%",
                  borderBottom: isPhoneSize ? "none" : "2px solid #070A0E",
                  fontSize: "1.1rem", // Increase font size
                  fontWeight: "bold"  // Make text bold
                }}
              >
                Events
                <span className={styles.events_number_circle}>
                  {sitesEventObject && sitesEventObject[relevantSite]
                    ? sitesEventObject[relevantSite].length
                    : 0}
                </span>
              </div>

              </div>
              <div className={styles.sortOptionContainer}>
                <SortChipRow
                  sortOption={sortOption}
                  sortDirection={sortDirection}
                  onChange={(option, direction) => {
                    setSortOption(option);
                    setSortDirection(direction);
                  }}
                />
              </div>


              <div>
              {sitesEventObject && sitesEventObject[relevantSite]
                ? sortEvents(sitesEventObject[relevantSite].slice()).map((event, index) => (
                    <EventItem
                      resolveEvent={resolveEvent}
                      key={`event-item-${event.name}-${index}`}
                      event={event}
                      focusOnCart={focusOnCart}
                      callBack={callBack}
                      assistCart={assistCart}
                      
                      openCamerasModal={openCamerasModal}
                      openRecorderModal={openRecorderModal}
                    />
                  ))
                : null}
              </div>
            </div>
          </div>
        </div>
      ) : null}



        {/* Always render modals - they can be used on mobile when in slider */}
        <CartAudioRecorderModal
          open={openRecorder}
          onClose={closeRecorderModal}
          baseUrl={relevantUrl}
          cartNumber={cartModalControlId}
        />

        <CartCameraModal
          open={openCameras}
          onClose={closeCamerasModal}
          cartId={cartModalControlId}
          isPhoneSize={isPhoneSize}
        />

    </div>
  );
}
